// extracted by mini-css-extract-plugin
export default {"cls1":"NavigationDrawerMobileNestedMenu-TitleIcon_cls1__Cckvg","cls2":"NavigationDrawerMobileNestedMenu-TitleIcon_cls2__LxGXh NavigationDrawerMobileNestedMenu-TitleIcon_cls1__Cckvg"};